export enum ControlType {
    Text = 1,
    Date = 2,
    Number = 3,
    Boolean = 4
}